import { EntityTechdocsContent } from '@backstage/plugin-techdocs';
import { TechDocsAddons } from '@backstage/plugin-techdocs-react';
import { ReportIssue } from '@backstage/plugin-techdocs-module-addons-contrib';
import { CustomTechdocsStyling } from '@internal/techdocs-addon-custom-styling';
import { TechdocsDisclaimerBanner } from '@internal/techdocs-addon-disclaimer-banner';
import { Katex } from '@internal/techdocs-addon-katex';
import { Mermaid } from 'backstage-plugin-techdocs-addon-mermaid';

export const techdocsContent = (
  <EntityTechdocsContent>
    <TechDocsAddons>
      <CustomTechdocsStyling />
      <TechdocsDisclaimerBanner />
      <ReportIssue />
      <Mermaid />
      <Katex />
    </TechDocsAddons>
  </EntityTechdocsContent>
);
